"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class JQLError {
    constructor(start, stop, message) {
        this.start = start;
        this.stop = stop;
        this.message = message;
    }
}
class JastBuilderErrorListener {
    constructor() {
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg, e) => {
            if (offendingSymbol === undefined) {
                // TODO what error do we show
            }
            else {
                this.errors.push(new JQLError(offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, msg));
            }
        };
    }
}
exports.default = JastBuilderErrorListener;
//# sourceMappingURL=JastBuilderErrorListener.js.map